import type { CollectInputAnswer } from "../schemas/icertis"
import type { WebAppFetch } from "./webAppFetch"

export async function saveCollectInputAnswer(
  webAppFetch: WebAppFetch,
  conversationId: string,
  toolCallId: string,
  answer: CollectInputAnswer,
): Promise<void> {
  await webAppFetch(`/api/chat/conversation/${conversationId}/answer`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ toolCallId, answer }),
  })
}
